import { Company } from '../../company/Company.interface';
import { RootState } from '../rootReducer';

export const getCompany = (state: RootState): Company|null => state.company.data;
